import { useCallback } from 'react';

import { batch, useDispatch, useSelector } from 'react-redux';

import { closeModalAction } from 'store/modal';
import { landingDataSelector } from 'store/page/selectors';
import { setLandingDataThunk } from 'store/page/thunks';

function useUpdatePrimaryPhoto() {
  const landing = useSelector(landingDataSelector);
  const dispatch = useDispatch();

  return useCallback(
    ({ asset, point = asset?.imageCoords }) => {
      const pages = [...landing.pages];

      pages[0] = {
        ...pages[0],
        primaryImageId: asset?.id || null,
        primaryImageUrl: asset?.url || null,
        primaryImageCoords: point || null,
        primaryImageVersion400: asset?.version400 || null,
        primaryImageVersion800: asset?.version800 || null,
        primaryImageVersion1200: asset?.version1200 || null,
        primaryImageVersion1600: asset?.version1600 || null,
        primaryImageVersion2400: asset?.version2400 || null,
      };

      batch(() => {
        dispatch(setLandingDataThunk({ ...landing, pages }));
        dispatch(closeModalAction());
      });
    },
    [landing, dispatch],
  );
}

export default useUpdatePrimaryPhoto;
